module.exports = __webpack_public_path__ + "static/product-logo-vmware-3cab7a34f0a80ac5965bda2e0c0e35bf.png";